import service from "./index";
import Qs from 'qs'

/**
 * 初始化数据
 */
export function countryApi (data) {
  return service.request({
    method: "post",
    url: "/newedition/answer/initdata",
    data: data
  })
}

/**
 * 答案列表
 */
export function answerlist (data) {
  console.log(data);
  return service.request({
    method: "post",
    url: "/newedition/answer/answerlist",
    data: data
  })
}

/**
 * 点赞
 */
export function like (data) {
  return service.request({
    method: "post",
    url: "/newedition/answer/like",
    data: data
  })
}

/**
 * 收藏
 */
export function collections (data) {
  return service.request({
    method: "post",
    url: "/newedition/answer/collections",
    data: data
  })
}

/**
 * 取消收藏
 */
export function cancelcollections (data) {
  return service.request({
    method: "post",
    url: "/newedition/answer/cancelcollections",
    data: data
  })
}

/**
 * 保存打赏
 */
export function savereward (data) {
  return service.request({
    method: "post",
    url: "/newedition/answer/savereward",
    data: data
  })
}

/**
 * 保存投票
 */
export function savevote (data) {
  return service.request({
    method: "post",
    url: "/newedition/answer/savevote",
    data: data
  })
}

/**
 * 答案详情
 */
export function answerDetail (data) {
  return service.request({
    method: "post",
    url: "/newedition/answer/detail",
    data: data
  })
}

/**
 * 浏览记录
 */
export function qaSee (data) {
  return service.request({
    method: "post",
    url: "/newedition/answer/historylist",
    data: data
  })
}

/**
 * 保存评论
 */
export function savecomment (data) {
  return service.request({
    method: "post",
    url: "/newedition/answer/savecomment",
    data: data
  })
}

/**
 * 评论数据
 */
export function commentlist (data) {
  return service.request({
    method: "post",
    url: "/newedition/answer/commentlist",
    data: data
  })
}

/**
 * 评论点赞
 */
export function commentlike (data) {
  return service.request({
    method: "post",
    url: "/newedition/answer/commentlike",
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/qa.js